import { Medium } from '@energiebespaarders/symbols/helpers';
import {
  ChatAlertAlt,
  ClipboardCheck,
  FileEuro,
  Shield,
  WrenchScrewdriver,
} from '@energiebespaarders/symbols/icons/solid';
import { QuoteInfoAccordion } from '../utils';
import { debWarranty } from './constants';

export const homeBatteryInfoAccordions = (
  needsPtc: boolean,
  needsPrepayment: boolean,
): QuoteInfoAccordion[] => [
  {
    key: 'feasibility',
    title: 'Technische haalbaarheid en volledigheid',
    paragraphs: [
      'Deze offerte is geldig onder voorbehoud van technische haalbaarheid en volledigheid. Dit betekent dat er een technische controle nodig is, waarna er nog mutaties kunnen plaatsvinden, afhankelijk van eventuele complicaties en/of meerwerk.',
    ],
    icon: ClipboardCheck,
    hide: !needsPtc,
  },
  {
    key: 'warranty',
    title: 'Installatiegarantie en service',
    paragraphs: [
      'Na inbedrijfstelling is er 1 jaar installatiegarantie. Dit omvat het gratis verhelpen van storingen die niet het gevolg zijn van onjuist of onoordeelkundig gebruik, onjuist onderhoud of ander verzuim door de gebruiker. Het normale onderhoud is niet in de prijs inbegrepen. We informeren u graag over een onderhoudscontract.',
      debWarranty,
    ],
    icon: Shield,
  },
  {
    key: 'invoicing',
    title: 'Facturatie',
    paragraphs: [
      ...(needsPrepayment
        ? [
            <p key="homeBattery-invoicing-0">
              <Medium>Aanbetaling:</Medium> 25% van het totale offertebedrag wordt na het accepteren
              van de definitieve offerte {needsPtc ? '(dus na de technische controle) ' : ''}in
              rekening gebracht.
            </p>,
            <p key="homeBattery-invoicing-1">
              <Medium>Facturatie:</Medium> 75% van het totale offertebedrag na oplevering.
            </p>,
          ]
        : [
            <p key="homeBattery-invoicing-1">
              <Medium>Facturatie:</Medium> het totale offertebedrag na oplevering.
            </p>,
          ]),
      <p key="homeBattery-invoicing-2">
        <Medium>Betalingstermijn:</Medium> binnen 7 dagen na factuurdatum.
      </p>,
      <p key="homeBattery-invoicing-3">
        <Medium>Uitvoering:</Medium> in overleg, na ontvangst opdracht. Als u de opdracht wilt
        annuleren, zijn hier mogelijk kosten aan verbonden.
      </p>,
    ],
    icon: FileEuro,
  },

  {
    key: 'activities',
    title: 'Montage en coördinatie',
    paragraphs: [
      <p key="homeBattery-activities-1">
        De werkzaamheden bij het installeren van een nieuwe thuisbatterij bevatten in hoofdzaak:
      </p>,
      <ul key="homeBattery-activities-2">
        <li>Het monteren van de batterij met eventueel toebehoren;</li>
        <li>Het aanleggen van een verbinding tussen de thuisbatterijen en de meterkast;</li>
        <li>Het inregelen, testen en bedrijfsvaardig opleveren van de installatie;</li>
        <li>Het netjes achterlaten van de werkplek.</li>
      </ul>,
      <p key="homeBattery-activities-3">
        Indien niet anders vermeld, zijn de volgende werkzaamheden{' '}
        <Medium>niet in deze offerte opgenomen</Medium>:
      </p>,
      <ul key="homeBattery-activities-4">
        <li>Verhelpen van eventuele gebreken aan de bestaande installatie;</li>
        <li>Aanvullende kosten die samenhangen met onvoorziene- of meerwerkzaamheden.</li>
      </ul>,
    ],
    icon: WrenchScrewdriver,
  },
  {
    key: 'reminders',
    title: 'Let ook hierop',
    paragraphs: [
      <p key="homeBattery-reminders-1">
        Er zijn een aantal aandachtspuntjes voor u als bewoner om de uitvoer zo soepel mogelijk te
        laten verlopen:
      </p>,
      <ul key="homeBattery-reminders-2">
        <li>
          De werkplekken dient geheel vrij te zijn van obstakels voordat de installatiewerkzaamheden
          starten;
        </li>
        <li>De bewoner draagt zorg voor een vrije parkeerplaats bij de woning.</li>
      </ul>,
    ],
    icon: ChatAlertAlt,
  },
];
